import { render, staticRenderFns } from "./NovoUsuario.vue?vue&type=template&id=e93c7f76&scoped=true&"
import script from "./NovoUsuario.vue?vue&type=script&lang=js&"
export * from "./NovoUsuario.vue?vue&type=script&lang=js&"
import style0 from "./NovoUsuario.vue?vue&type=style&index=0&id=e93c7f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93c7f76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
